import { Distretto, AziendaSanitaria, AreaVasta, Macrozona } from './anagrafica_geo';
import { Struttura } from './struttura';
import { Deserializable, HmModelRest } from './abstract_model';

import * as _ from 'lodash-es';
import { userRole } from '@hm_app/users/users-auth-guard';
import { adminOrOperatorRole, superAdminRole, adminOrSuperAdminRole, monitorRole } from '@hm_app/_helpers/roles';
import { RuoliUtente, Utente } from './utente';
import { environment } from '@src/environments/environment';
import { Gravidanza } from './gravidanza';


type ResolveCapFunct = (cap: UserCapability) => Promise<AreaVasta | AziendaSanitaria | Macrozona | Distretto | Struttura>;
export interface CapabilityResolver {
  entityFromCapability(cap: UserCapability): Promise<AreaVasta | AziendaSanitaria | Macrozona | Distretto | Struttura>;

  areaVastaByRef(ref: number | AreaVasta): Promise<AreaVasta>;

  aziendaSanitariaByRef(ref: number | AziendaSanitaria): Promise<AziendaSanitaria>;
  aziendaSanitariaByAreaVasta(ref: number | AreaVasta): Promise<AziendaSanitaria[]>;

  macrozonaByRef(ref: number | Macrozona): Promise<Macrozona>;
  macrozoneByAziendaSanitaria(ref: number | AziendaSanitaria): Promise<Macrozona[]>;

  distrettoByRef(ref: number | Distretto): Promise<Distretto>;
  distrettiByMacrozona(ref: number | Macrozona): Promise<Distretto[]>;

  strutturaByRef(ref: number | Struttura): Promise<Struttura>;
  struttureByDistretto(ref: number | Distretto): Promise<Struttura[]>;

}

export enum CapabilityRole {
  VIEW = 'view',
  EDIT = 'edit',
  STATS = 'stats',
  CAN = 'can',
  NASCITA = 'nascita',
  INDAGINE = 'indagine',
  CONTROLLO = 'controllo'
}

export const CapabilityRoleValues = [
  {
    key: CapabilityRole.EDIT,
    label: "Edit"
  },
  {
    key: CapabilityRole.STATS,
    label: "Stats"
  },
  {
    key: CapabilityRole.CAN,
    label: "Can"
  },
  {
    key: CapabilityRole.NASCITA,
    label: "Nascita"
  },
  {
    key: CapabilityRole.INDAGINE,
    label: "Indagine"
  },
  {
    key: CapabilityRole.CONTROLLO,
    label: "Controllo"
  },
]

export enum CapabilityType {
  AREA_VASTA = 'area_vasta',
  AZIENDA_SANITARIA = 'azienda_sanitaria',
  AOU = 'AOU',
  MACROZONA = 'macrozona',
  DISTRETTO = 'distretto',
  STRUTTURA = 'struttura',
}

export const CapabilityTypeValues = [
  {
    key: CapabilityType.AREA_VASTA,
    label: "Area Vasta"
  },
  {
    key: CapabilityType.AZIENDA_SANITARIA,
    label: "Azienda Sanitaria"
  },
  /* {
    key: CapabilityType.MACROZONA,
    label: "Macrozona"
  }, */
  {
    key: CapabilityType.AOU,
    label: "AOU "
  },
  {
    key: CapabilityType.DISTRETTO,
    label: "Distretto"
  },
  {
    key: CapabilityType.STRUTTURA,
    label: "Struttura"
  },
]




export class Capability extends Deserializable {
  user_role: CapabilityRole;

  aree_vaste: AreaVasta[] = [];
  aziende_sanitarie: AziendaSanitaria[] = [];
  macrozone: Macrozona[] = [];
  distretti: Distretto[] = [];
  strutture: Struttura[] = [];


  addAreaVasta(a: AreaVasta) {
    if (!this.aree_vaste.indexOf(a)) {
      this.aree_vaste.push(a);
    }
  }

  addAziendaSanitaria(a: AziendaSanitaria) {
    if (this.aziende_sanitarie.indexOf(a) < 0) {
      this.aziende_sanitarie.push(a);
    }
  }

  addMacrozona(m: Macrozona) {
    if (this.macrozone.indexOf(m) < 0) {
      this.macrozone.push(m);
    }
  }
  addDistretto(d: Distretto) {
    if (this.distretti.indexOf(d) < 0) {
      this.distretti.push(d);
    }
  }
  addStruttura(s: Struttura) {
    if (this.strutture.indexOf(s) < 0) {
      this.strutture.push(s);
    }
  }

  addEntity(entity: AreaVasta | AziendaSanitaria | Macrozona | Distretto | Struttura) {
    if (entity instanceof AreaVasta) {
      this.addAreaVasta(entity as AreaVasta);
    } else if (entity instanceof AziendaSanitaria) {
      this.addAziendaSanitaria(entity as AziendaSanitaria);
    } else if (entity instanceof Macrozona) {
      this.addMacrozona(entity as Macrozona);
    } else if (entity instanceof Distretto) {
      this.addDistretto(entity as Distretto);
    } else if (entity instanceof Struttura) {
      this.addStruttura(entity as Struttura);
    }
  }

  async resolverAllEntities(resolver: CapabilityResolver) {

    for (const av of this.aree_vaste) {
      const azs = await resolver.aziendaSanitariaByAreaVasta(av);
      for (const az of azs) {
        this.addAziendaSanitaria(az);
      }
    }

    for (const az of this.aziende_sanitarie) {
      const mzs = await resolver.macrozoneByAziendaSanitaria(az);
      for (const m of mzs) {
        this.addMacrozona(m);
      }
    }

    for (const m of this.macrozone) {
      const dst = await resolver.distrettiByMacrozona(m);
      for (const d of dst) {
        this.addDistretto(d);
      }
    }

    for (const d of this.distretti) {
      const strs = await resolver.struttureByDistretto(d);
      for (const s of strs) {
        this.addStruttura(s);
      }
    }
  }
}

export class UserCapability extends HmModelRest {
  user_role: CapabilityRole | string;

  entity_type: CapabilityType;
  entity_id: number;
  entity: AreaVasta | AziendaSanitaria | Macrozona | Distretto | Struttura;

}

export abstract class AbstractUser extends HmModelRest {
  id: number;
  nome: string;
  cognome: string;
  username: string;
  cod_fiscale: string;
  role: RuoliUtente;
  capabilities: UserCapability[];

  capability_rules = {
    'view': new Capability(),
    'edit': new Capability(),
    'stats': new Capability(),
    'can': new Capability(),
    'nascita': new Capability(),
    'controllo': new Capability()
  };

  deserialize(input: any) {
    super.deserialize(input);

    if (this.capabilities) {
      this.capabilities = this.capabilities.map(item => new UserCapability().deserialize(item));
    }
    return this;
  }



  get isUser(): boolean {
    return userRole(this.role);
  }

  get isAdmin(): boolean {
    return adminOrSuperAdminRole(this.role);
  }

  get isSuperAdmin(): boolean {
    return superAdminRole(this.role);
  }

  get isAdminOrOperator(): boolean {
    return adminOrOperatorRole(this.role);
  }

  get isMonitor(): boolean {
    return monitorRole(this.role);
  }

  async resolveCapabilities(resolver: CapabilityResolver) {
    for (const c of this.capabilities) {
      const entity = await resolver.entityFromCapability(c);
      if (entity) {
        c.entity = entity;
        if (!this.capability_rules[c.user_role]) {
          this.capability_rules[c.user_role] = new Capability();
        }
        this.capability_rules[c.user_role].addEntity(entity);
      }
    }

    for (const k of Object.keys(this.capability_rules)) {
      await this.capability_rules[k].resolverAllEntities(resolver);
    }

    // console.log('capabs', this.capability_rules);

  }

}

export interface CapTreeItem {
  area_vasta?: number[];
  azienda_sanitaria?: number[];
  distretto?: number[];
  struttura?: number[];
}


export interface CapTree {
  nascita?: CapTreeItem;
  can?: CapTreeItem;
  edit?: CapTreeItem;
  controllo?: CapTreeItem;
  indagine?: CapTreeItem;
  stats?: CapTreeItem;
}


export class AuthUser extends AbstractUser {

  email: string;
  data_nascita: string;
  source: string;
  auth_level: number;
  ente_appartentenza: number;
  azienda_sanitaria: number;
  comune_riferimento: number;
  consultorio_operatore: number;
  moodle_id: number;
  captree: CapTree;

  get login_can(): boolean {

    return _.find(this.capabilities, { user_role: CapabilityRole.CAN });
    //return !this.isUser;
  }


  get has_capability_controllo(): boolean {

    return _.find(this.capabilities, { user_role: CapabilityRole.CONTROLLO });
    //return !this.isUser;
  }


  get auth_strong(): boolean {
    return this.auth_level >= environment.min_auth_level_strong;
  }

  get has_role_percorso_nascita() {
    if (this.isSuperAdmin) {
      return true;
    }
    if (!this.auth_strong) {
      return false;
    }
    return [RuoliUtente.medico_generico, RuoliUtente.medico_ginecologo, RuoliUtente.ostetrica].includes(this.role);
  }

  get has_role_permessi_tab() {
    if (this.isSuperAdmin) {
      return true;
    }
    if (!this.auth_strong) {
      return false;
    }
    return [RuoliUtente.operatore, RuoliUtente.medico_ginecologo, RuoliUtente.ostetrica].includes(this.role);
  }

  has_role_edit_mestruazione(gravidanza: Gravidanza, paziente: Utente) {
    if (this.isSuperAdmin) {
      return true;
    }
    if (!this.auth_strong) {
      return false;
    }

    const distretto_id = gravidanza.distretto;

    const isGinecologoOrOstetrica = [RuoliUtente.medico_ginecologo, RuoliUtente.ostetrica].includes(this.role);
    const hasControlloOrNascitaOnDistrettoGravidanza = (this.isAuthorized(CapabilityRole.CONTROLLO, CapabilityType.DISTRETTO, distretto_id) ||
      this.isAuthorized(CapabilityRole.NASCITA, CapabilityType.DISTRETTO, distretto_id));
    const isAuthorized = this.is_forced_authorized(paziente);

    return isGinecologoOrOstetrica && (hasControlloOrNascitaOnDistrettoGravidanza || isAuthorized);
  }

  is_forced_authorized(utente: Utente): boolean {
    let isauthorized = this.is_authorized_by_user(utente);
    isauthorized = isauthorized || this.is_authorized_by_district(utente);
    isauthorized = !this.is_blocked_by_user(utente) && isauthorized;
    return isauthorized;
    //return !this.is_blocked_by_user(utente) && (this.is_authorized_by_user(utente) || this.is_authorized_by_district(utente));
  }

  is_authorized_by_user(utente: Utente) {
    return this.get_cf_status(utente) == 'authorized';
  }

  is_blocked_by_user(utente: Utente) {
    let status = this.get_cf_status(utente);
    return status != null && status != 'authorized';
  }

  is_authorized_by_district(utente: Utente) {
    if (!utente.autorizzazione_distretti)
      return false;
    const districts_authorized = utente.autorizzazione_distretti.filter(auth =>
      this.isAuthorized(CapabilityRole.NASCITA, CapabilityType.DISTRETTO, auth.distretto instanceof Distretto ? auth.distretto.id : auth.distretto) ||
      this.isAuthorized(CapabilityRole.CONTROLLO, CapabilityType.DISTRETTO, auth.distretto instanceof Distretto ? auth.distretto.id : auth.distretto)
    );
    if (districts_authorized.length == 0)
      return false;
    return districts_authorized.filter(d => d.status == 'authorized').length > 0;
  }

  get_cf_status(utente: Utente) {
    if (!utente.autorizzazione_medici)
      return null;
    const cfs_authorized = utente.autorizzazione_medici.filter(auth => auth.cf_medico == this.cod_fiscale);
    if (cfs_authorized.length == 0)
      return null;
    return cfs_authorized[0].status;
  }




  get has_role_force_permission_user_data() {
    return this.isSuperAdmin || this.auth_strong;
  }


  get has_role_cartaceo_to_digitale() {
    if (this.isSuperAdmin) {
      return true;
    }
    if (!this.auth_strong) {
      return false;
    }
    return [RuoliUtente.ostetrica].includes(this.role);
  }

  get has_role_digitale_to_cartaceo() {
    if (this.isSuperAdmin) {
      return true;
    }
    if (!this.auth_strong) {
      return false;
    }
    return [RuoliUtente.ostetrica, RuoliUtente.medico_ginecologo, RuoliUtente.operatore].includes(this.role);
  }

  isAuthorized(capability_role: CapabilityRole, capability_category: CapabilityType, category_id: number): boolean {
    if (!(capability_role in this.captree))
      return false;
    if (!(capability_category in this.captree[capability_role]))
      return false;
    if (!(this.captree[capability_role][capability_category].includes(category_id)))
      return false;
    return true;
  }

  isAuthorizedByCategory(capability_role: CapabilityRole, capability_category: CapabilityType): boolean {
    if (!(capability_role in this.captree))
      return false;
    if (!(capability_category in this.captree[capability_role]))
      return false;
    if ((this.captree[capability_role][capability_category].length <= 0))
      return false;
    return true;
  }


  isAuthorizedByRole(capability_role: CapabilityRole): boolean {
    let ret = false;
    if (!(capability_role in this.captree))
      return false;
    Object.keys(this.captree[capability_role]).forEach(c => {
      if (this.captree[capability_role][c].length > 0)
        ret = true;
    })
    return ret;
  }


  get has_role_stats(): boolean {
    if (this.isSuperAdmin) {
      return true;
    }
    return (this.isAuthorizedByRole(CapabilityRole.STATS) || this.isAuthorizedByRole(CapabilityRole.CONTROLLO)) && [RuoliUtente.operatore, RuoliUtente.medico_ginecologo, RuoliUtente.ostetrica].includes(this.role);
  }

  get has_role_indagine(): boolean {
    if (this.isSuperAdmin) {
      return true;
    }
    return this.isAuthorizedByRole(CapabilityRole.INDAGINE) || this.isAuthorizedByRole(CapabilityRole.CONTROLLO)
  }

  get has_role_controllo(): boolean {
    if (this.isSuperAdmin) {
      return true;
    }
    return this.isAuthorizedByRole(CapabilityRole.CONTROLLO)
  }


  get has_role_manage_can(): boolean {
    if (this.isSuperAdmin) {
      return true;
    }
    if (!this.auth_strong) {
      return false;
    }
    return (this.isAuthorizedByRole(CapabilityRole.CAN) || this.isAuthorizedByRole(CapabilityRole.CONTROLLO)) && [RuoliUtente.operatore, RuoliUtente.medico_ginecologo, RuoliUtente.ostetrica].includes(this.role);
  }


  get has_role_can_edit_cf(): boolean {
    if (this.isSuperAdmin) {
      return true;
    }
    if (!this.auth_strong) {
      return false;
    }
    return [RuoliUtente.ostetrica, RuoliUtente.medico_ginecologo, RuoliUtente.operatore].includes(this.role);
  }
}
